export default "__VITE_ASSET__6a5172c6__"